import { isPast } from 'date-fns'
import { shallowEqual, useSelector } from 'react-redux'

import { ActionBarLeft, ActionBarRight, ActionBarWrapper } from '@components/UI/Card/Card.styled'
import { useInboxFilter } from '@hooks/useInboxFilter'
import { IApplicationState } from '@store/index'
import { ISubmission, selectComparisonLink } from '@store/submissions'
import ActionBarIconChat from '../Icon/Chat'
import ActionBarIconCompareSubmission from '../Icon/CompareSubmission/CompareSubmission'
import { ActionBarIconDownload } from '../Icon/Download/Download'
import ActionBarIconLicense from '../Icon/License'
import ActionBarIconReschedule from '../Icon/Reschedule/Reschedule'
import SubmissionCardActionBarSocialPublishDate from './PublishDate'

interface IProps {
  campaignId: number
  submission: ISubmission
  hasFeedbackLink: boolean
  showLicenseIcon: boolean
  hasRescheduleLink: boolean
}

const SubmissionCardActionBarSocialApproved: React.FC<IProps> = ({
  hasRescheduleLink,
  hasFeedbackLink,
  submission,
  campaignId,
  showLicenseIcon,
}) => {
  const submissionId = submission.id
  const { hasComparisonLink } = useSelector((state: IApplicationState) => ({
    hasComparisonLink: Boolean(selectComparisonLink(state, submissionId)),
  }), shallowEqual)

  const { currentFilter } = useInboxFilter()
  const modalProps = {
    currFilter: currentFilter,
    submission,
    campaignId,
  }

  const isApprovedFilter = currentFilter === 'approved'
  const isPublishedFilter = currentFilter === 'published'
  const showComparisonLink = isPublishedFilter || isApprovedFilter

  return (
    <ActionBarWrapper justifyBetween>
      <ActionBarLeft>
        <SubmissionCardActionBarSocialPublishDate submission={submission} />
      </ActionBarLeft>
      <ActionBarRight>
        {hasRescheduleLink && (
          <ActionBarIconReschedule
            showNotification={isPast(new Date(submission.scheduled_publish_date as string))}
            highlighted={Boolean(submission.scheduled_publish_date)}
            modalProps={modalProps}
          />
        )}
        {hasFeedbackLink && <ActionBarIconChat submission={submission} campaignId={campaignId} />}
        {hasComparisonLink && showComparisonLink && (
          <ActionBarIconCompareSubmission submissionId={submissionId} campaignId={campaignId} />
        )}
        {showLicenseIcon && <ActionBarIconLicense submissionId={submissionId} />}
        {isPublishedFilter && <ActionBarIconDownload submissionId={submissionId} />}
      </ActionBarRight>
    </ActionBarWrapper>
  )
}

export default SubmissionCardActionBarSocialApproved
